/**
 * @author Gananath Athukporala
 * @version 0.1
 * @since 26/06/2023
 */
import React, { useState } from "react";
import api from "../../../../base/services/ResApi";
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling";
import PendingItemBody from "./PendingItemBody";

const PendingOrgsItem = (props) => {
  const [isBtnLoading, setIsBtnLoading] = useState(false);

  const handleAccept = (approveId) => {
    setIsBtnLoading(true);
    const payload = {
      approvedIdList: [
        {
          approvedId: approveId,
        },
      ],
      rejectedIdList: [],
    };

    api
      .patch("/organizations", payload)
      .then((res) => {
        setIsBtnLoading(false);
        props.setUpdateData(true)
        props.setIsSuccess(true);
        props.setSuccessMessages([res.data?.description]);
        props.setErrorMessages([]);
        props.setIserror(false);
       
      })
      .catch((error) => {
        setIsBtnLoading(false);
        props.setIsSuccess(false);
        RequestErrorHandeling(
          error,
          props.setIserror,
          props.setErrorMessages,
          props.setIserrorShow,
          props.setIsUnauhtError
        );
      });
  };

  const handleReject = (approveId) => {
    setIsBtnLoading(true);
    const payload = {
      approvedIdList: [],
      rejectedIdList: [
        {
          rejectedId: approveId,
        },
      ],
    };

    api
      .patch("/organizations", payload)
      .then((res) => {
        setIsBtnLoading(false);
        props.setUpdateData(true)
        props.setIsSuccess(true);
        props.setSuccessMessages([res.data?.description]);
        props.setErrorMessages([]);
        props.setIserror(false);
      })
      .catch((error) => {
        setIsBtnLoading(false);
        console.log(error);
        props.setIsSuccess(false);
        RequestErrorHandeling(
          error,
          props.setIserror,
          props.setErrorMessages,
          props.setIserrorShow,
          props.setIsUnauhtError
        );
      });
  };

  return (
    <PendingItemBody
      name={props.orgName}
      action={props.action}
      isBtnLoading={isBtnLoading}
      approveId={props.approveId}
      handleAccept={handleAccept}
      handleReject={handleReject}
    />
  );
};
export default PendingOrgsItem;
